import React from 'react';
import { Alert, Box, Button } from '@mui/material';

export default function PerformancePendingImportBanner({
    show,
    pendingRunId,
    onReview,
    onDismiss,
}) {
    if (!show) return null;

    return (
        <Alert
            severity="info"
            sx={{ mb: 1.5 }}
            action={(
                <Box sx={{ display: 'flex', gap: 0.75 }}>
                    <Button
                        color="inherit"
                        size="small"
                        onClick={onReview}
                        sx={{ textTransform: 'none', fontWeight: 700 }}
                    >
                        Review
                    </Button>
                    <Button
                        color="inherit"
                        size="small"
                        onClick={() => onDismiss(String(pendingRunId || ''))}
                        sx={{ textTransform: 'none' }}
                    >
                        Dismiss
                    </Button>
                </Box>
            )}
        >
            Actual portfolio updates available from Performance sync.
        </Alert>
    );
}
